import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { SystemStorageType } from "../../../system/systemEdit/SystemEdit.types.ts";
import { storageTypeOptions } from "../../../system/systemEnumOptions.ts";

export interface SystemStorageTypeFieldProps {
    storageType: SystemStorageType | undefined;
    onChange: (storageType: SystemStorageType | null) => void;
    readOnly?: boolean;
    disabled: boolean;
    errorText?: string;
}

function SystemStorageTypeField(props: SystemStorageTypeFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalSelect
            options={storageTypeOptions(translateString)}
            selectedItem={props.storageType === undefined || props.storageType === null ? null : props.storageType.toString()}
            onChange={
                props.readOnly
                    ? () => {}
                    : (type) => {
                          props.onChange(type ? (Number(type) as SystemStorageType) : null);
                      }
            }
            placeholder={translateString("storageType")}
            label={translateString("storageType")}
            noOptionsLabel={translateString("noOptions")}
            toolTipText={translateString("storageTypeTooltip")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default SystemStorageTypeField;
